<template>
  <div class="header_div header_div_mobile">
    <a-row>
      <a-col :span="12" class="header_logo" style="padding-left: 12px">
        <img :src="logoImg" :height="30"><br>
        <span class="env_title">从会销售的AI智能体开始</span>
      </a-col>

      <a-col :span="12" class="header_avatar" justify="end">
        <a-row type="flex" justify="end" align="middle" style="padding: 0 12px">
          <a-col :span="1" style="text-align: left;">
            <div class="split_div"></div>
          </a-col>
          <a-col style="margin-left: 5px">
            <span v-if="!haveLogin && !isMeuHost" @click="loginShow" class="login_txt">登录</span>
<!--            <span v-if="haveLogin" @click="exitShow" class="login_txt">退出</span>-->
          </a-col>
          <a-col v-if="haveLogin" style="display: flex;align-items: center;margin-left: 8px">
            <a-popconfirm trigger="hover" class="exitPop" placement="bottom" title="确认退出？" cancel-text="取消" ok-text="确定" @confirm="exitShow">
              <a-icon slot="icon" type="question-circle-o" style="color: #28E04A" />
              <div>
                <a-icon type="user" style="font-size:22px;line-height: 28px;margin-top: 3px"/><span> {{ username }} </span>
              </div>
            </a-popconfirm>
            <!--            <img :src="avatarUrl" width="28" height="28">-->
          </a-col>
        </a-row>
      </a-col>
    </a-row>

    <a-row type="flex" style="margin-top: 10px">
      <a-col flex="1" class="nav_item" @click="btnNavClick(0)" >
        <div class="nav_item_div">
          <div class="split_item">产品展示</div>
          <div class="split_item split_bottom" v-show="navIndex === 0"></div>
        </div>
      </a-col>
      <a-col flex="1" class="nav_item" @click="btnNavClick(1)" style="margin: 0 auto">
        <div class="nav_item_div">
          <div class="split_item">知识库</div>
          <div class="split_item split_bottom" v-show="navIndex === 1"></div>
        </div>
      </a-col>
      <a-col flex="1" class="nav_item" @click="btnNavClick(2)" style="margin: 0 auto">
        <div class="nav_item_div">
          <div class="split_item">下载</div>
          <div class="split_item split_bottom" v-show="navIndex === 2"></div>
        </div>
      </a-col>
      <a-col flex="1" class="nav_item" @click="btnNavClick(3)"  style="margin: 0 auto">
        <div class="nav_item_div">
          <div class="split_item">帮助中心</div>
          <div class="split_item split_bottom" v-show="navIndex === 3"></div>
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
export default {
  name: 'Header',
  props: {
    navIndex: {
      type: Number,
      default: 0
    }
  },
  inject: ['showLogin'],
  computed: {
    username () {
      return this.$store.state.userAuth.username
    },
    haveLogin () {
      return this.$store.state.userAuth.haveLogin
    },
    isMeuHost () {
      return this.$store.state.isMeuHost
    }
  },
  data () {
    return {
      msg: 'Welcome to Header App',
      haveLogin1: false,
      avatarUrl: require('@/assets/icon_avatar.png'),
      logoImg: require('@/assets/logo/logo.png')
    }
  },
  mounted () {
  },
  methods: {
    btnNavClick (index) {
      console.log('btnNavClick', index)
      if (this.$store.state.isMobile) {
        switch (index) {
          case 0:
            this.$router.push('/m')
            break
          case 1:
            this.$router.push('/m/base')
            break
          case 2:
            this.$router.push('/m/download')
            break
          case 3:
            this.$router.push('/m/help')
            break
          default:
            break
        }
      } else {
        switch (index) {
          case 0:
            this.$router.push('/')
            break
          case 1:
            this.$router.push('/base')
            break
          case 2:
            this.$router.push('/download')
            break
          case 3:
            this.$router.push('/help')
            break
          default:
            break
        }
      }
    },
    loginShow () {
      /* this.$router.push('/')
      this.$store.commit('updateShowPanel', true) */
      // this.$emit('showLogin')
      this.showLogin()
    },
    exitShow () {
      this.$store.commit('updateUserAuth', {})
      this.$store.commit('updateUserInfo', {mall_state: -1})
      this.$store.commit('updateProject0', {
        'ai_prompt': '',
        'comment': '默认项目',
        'db_prompt': '你是我的小助手，会帮我回答一些用户提问',
        'engine': 'ai',
        'id': -1,
        'max_tokens': 2048,
        'model': 'gpt-3.5-turbo',
        'name': '默认项目-',
        'owner': ''
      })
      this.$store.commit('updateShowPanel', false)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .ant-popover-buttons{
    .ant-btn-primary{
      background: #28E04A;
      border-color: #28E04A;
    }
    .ant-btn-primary:hover{
      background: #28E04A;
    }
  }
</style>
<style lang="less">
  .header_div_mobile{
    .nav_item {
      width: 100px;
      height: auto;
      margin: 0;
      .nav_item_div{
        width: 100%;
        height: 50px;
        display: flex;
        flex-direction: column; /* 垂直排列 */
        justify-content: center;
        align-items: center;
        .split_item{
          margin-bottom: 5px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/mobile/HeaderMobile.vue